var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgNoFood = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2767_559)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.98555 6.74496L8.70847 3.95829H12.6668V0.791626H14.2501V3.95829H18.2085L17.116 14.8754L14.2501 12.0095L8.98555 6.74496ZM17.3376 17.3375L1.66264 1.66246L0.546387 2.77871L5.05889 7.29121C2.7393 7.78204 0.791803 9.30996 0.791803 11.875H9.63472L11.2181 13.4583H0.791803V15.0416H12.6668V14.907L16.2214 18.4616L17.3376 17.3375ZM0.791803 18.2083H12.6668V16.625H0.791803V18.2083Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2767_559"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNoFood, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/no_food.15249883.svg";
export { ForwardRef as ReactComponent };